// Préférences de langue du visiteur : langue de l'interface (`ui-language`) et langue du catalogue
// « Nos livres » (`catalog-language`). Gardées dans localStorage ET dans un cookie du même nom : le
// serveur ne voit pas localStorage, or c'est lui qui génère la page des URL sans code langue
// (/izvor/, /P0225FR, /book/slug…) — voir readPreferences dans server/index.mjs. Cookie technique
// nécessaire (mémoriser la langue de navigation), déjà déclaré dans le bandeau cookies.
export const UI_LANGUAGE_KEY = 'ui-language';
export const CATALOG_LANGUAGE_KEY = 'catalog-language';

const ONE_YEAR = 60 * 60 * 24 * 365;

export function savePreference(key, value) {
  if (!value) {
    return;
  }
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // stockage indisponible : le cookie suffit au serveur
  }
  document.cookie = `${key}=${encodeURIComponent(value)}; path=/; max-age=${ONE_YEAR}; SameSite=Lax`;
}

export function readPreference(key) {
  try {
    return window.localStorage.getItem(key) || '';
  } catch {
    return '';
  }
}
